import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=6daf8fb0"
import script from "./AvatarMenu.vue?vue&type=script&lang=js"
export * from "./AvatarMenu.vue?vue&type=script&lang=js"
import style0 from "./AvatarMenu.vue?vue&type=style&index=0&id=6daf8fb0&prod&lang=scss"
import style1 from "./AvatarMenu.vue?vue&type=style&index=1&id=6daf8fb0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports